var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKavidaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.797,
    height: 26.527,
    viewBox: "0 0 116.797 26.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.013,
    y1: 0.179,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f88ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1999a3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "kavida-log",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15774",
    "data-name": "Group 15774",
    transform: "translate(0)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6256",
    "data-name": "Path 6256",
    d: "M7.285,4.7V-2.442h3L14.579,4.7h6.71L14.931-5.563l6.4-9.362h-6.71L10.171-7.669H7.285V-21.44H1.472V4.7Zm21.261.39a7.759,7.759,0,0,0,6.671-3.043h.234V4.7h5.422V-6.928c0-5.227-3.043-8.387-8.816-8.387-5.539,0-9.167,3.082-9.167,7.763v.429h5.578v-.429c0-1.99.936-2.653,3.316-2.653,2.3,0,3.55.429,3.55,2.731v.624l-6.71,1.014c-4.057.624-6.242,2.5-6.242,5.539C22.382,3.254,25.073,5.087,28.545,5.087ZM27.96-.764c0-.819.546-1.209,1.755-1.4l5.618-.858C35.333.016,32.875.64,30.5.64,28.779.64,27.96.289,27.96-.764ZM57.686,4.7l7.646-19.622h-6.4l-4.681,14h-.429l-4.681-14H42.628L50.235,4.7ZM72.9-17.149V-21.44H67.088l.078,4.291ZM73.017,4.7V-14.925H67.166V4.7Zm11.625.39c2.887,0,5.11-1.17,6.125-3.277h.2V4.7h5.422V-21.44H90.572v9.089h-.234c-.9-1.638-2.692-2.965-5.7-2.965-5.344,0-8.5,4.018-8.5,10.221C76.138,1.069,79.1,5.087,84.642,5.087ZM81.95-5.095c0-3.589.936-5.227,4.33-5.227,2.77,0,4.291.975,4.291,3.628v3.16c0,2.653-1.521,3.628-4.291,3.628C82.887.094,81.95-1.545,81.95-5.095ZM105.942,5.087a7.759,7.759,0,0,0,6.671-3.043h.234V4.7h5.422V-6.928c0-5.227-3.043-8.387-8.816-8.387-5.539,0-9.167,3.082-9.167,7.763v.429h5.578v-.429c0-1.99.936-2.653,3.316-2.653,2.3,0,3.55.429,3.55,2.731v.624l-6.71,1.014c-4.057.624-6.242,2.5-6.242,5.539C99.778,3.254,102.47,5.087,105.942,5.087Zm-.585-5.852c0-.819.546-1.209,1.755-1.4l5.618-.858c0,3.043-2.458,3.667-4.837,3.667C106.176.64,105.357.289,105.357-.764Z",
    transform: "translate(-1.472 21.44)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKavidaLogo);
export default __webpack_public_path__ + "static/media/kavida-logo.14f7e62090d7813fe446aa7625b762a8.svg";
export { ForwardRef as ReactComponent };